module.exports = __webpack_public_path__ + "img/fumble.8843e0d2.jpg";